/*
 * @Author: Lim 
 * @Date: 2020-09-10 14:58:08 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-11 11:06:13
 */
import React, { useState, useEffect, useRef } from 'react';
import style from "./Loading.module.scss";
import { initConfig } from '../common';

export default (props) => {
    /**
     * default
     * 默认数据
     */
    const defaultConfig = {
        position: 'fixed',
        delay: 0,
        bgColor: 'rgba(255,255,255,.7)',
        loadingColor: '#3B99FC',
        spinning: false,
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     */
    const { 
        position,
        delay, 
        bgColor, 
        loadingColor, 
        spinning
    } = initConfig( defaultConfig, props.config );
    
    const defaultDelay = parseInt ( delay ) ;
    /**
     * state
     * loading开关
     */
    const [ loadingSwitch, setLoadingSwitch ] = useState( false );
    /**
     * refs
     * 延迟显示
     */
    let laterTimer = useRef();
    /**
     * didmount & update & unMount
     * update & unMount 
     */
    useEffect(() => {
        if( defaultDelay >= 0 && spinning === true ){
            laterTimer.current = setTimeout(()=>{
                setLoadingSwitch( true )
            },defaultDelay)
        }else{
            setLoadingSwitch( false )
            clearTimeout( laterTimer.current );
        }
        return () => {
            setLoadingSwitch( false )
            clearTimeout( laterTimer.current );
        }
    },[ spinning ])
    /**
     * Func
     * 点击选择
     */
    /**
     * DOM
     */
    return(
        <div className={ style.loading } style = {{ position, display: loadingSwitch ? "block" : "none", background: bgColor }}>
            <div className={ style.main }>
                <div className={ style.load } style={{ color:loadingColor }}></div>
                { props.children }
            </div>
        </div>
    )
}